import type { IconName } from '../utils/icons'

export const brandName = 'Inglese Pronto™'
export const price = '€19'
export const priceCurrency = 'EUR'
export const fullPrice = '€110'

export type Stat = {
  value: number
  prefix?: string
  suffix?: string
  label: string
}

export const stats: Stat[] = [
  { value: 6, label: 'Volumi digitali pronti all’uso' },
  { value: 1500, prefix: '+', label: 'Docenti soddisfatti in tutta Italia' },
  { value: 5200, suffix: '+', label: 'Ore di pianificazione risparmiate' },
  { value: 98, suffix: '%', label: 'Lo raccomandano ai colleghi' },
]

export const differenceStats: Stat[] = [
  {
    value: 6,
    label: 'Livelli QCER, dall’A1 al C2: unità e attività complete',
  },
  { value: 6, label: 'Volumi con un percorso editoriale fluido e coerente' },
  { value: 100, suffix: '%', label: 'Digitale: accesso immediato dopo il pagamento' },
]

export const marqueeItems = [
  'Download istantaneo',
  'Pagamento unico',
  'Accesso a vita',
  'Livelli A1 → C2',
  'Design editoriale premium',
]

export type ComparisonRow = {
  beforeTitle: string
  beforeText: string
  afterTitle: string
  afterText: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    beforeTitle: 'Ore rubate',
    beforeText: 'Fine settimana interi passati su Google o Pinterest.',
    afterTitle: 'Sicurezza totale',
    afterText: '5 minuti di lettura ed entri in aula con autorità.',
  },
  {
    beforeTitle: 'Caos in aula',
    beforeText: 'Attività che non funzionano per quel livello.',
    afterTitle: 'Progressione reale',
    afterText: 'Materiale testato e adattato al QCER.',
  },
  {
    beforeTitle: 'Zero struttura',
    beforeText: 'Lezioni slegate, senza connessione tra loro.',
    afterTitle: 'Pianificazione annuale',
    afterText: 'Un filo conduttore dall’A1 al C2.',
  },
  {
    beforeTitle: 'Burocrazia infinita',
    beforeText: 'Stress ogni volta che servono report e rubriche.',
    afterTitle: 'Valutazione express',
    afterText: 'Griglie e placement test pronti al 100%.',
  },
  {
    beforeTitle: 'Studenti dispersi',
    beforeText: 'Si annoiano perché “è sempre lo stesso”.',
    afterTitle: 'Motivazione estrema',
    afterText: 'Materiale visivo che li tiene attivi e coinvolti.',
  },
]

export type RecognizeItem = {
  icon: IconName
  title: string
  text: string
}

export const recognizeItems: RecognizeItem[] = [
  {
    icon: 'brain',
    title: 'Ansia della domenica sera',
    text: 'Arrivare al lunedì senza sapere cosa fare con quel gruppo difficile.',
  },
  {
    icon: 'calendarX',
    title: 'Domeniche rubate',
    text: 'Passare il giorno a scrivere programmazioni per i dirigenti invece di riposare.',
  },
  {
    icon: 'fileSearch',
    title: 'Caos creativo',
    text: 'Cercare schede moderne, ma trovare solo fotocopie sfocate di 20 anni fa.',
  },
  {
    icon: 'clipboardList',
    title: 'Valutazione eterna',
    text: 'Non avere un metodo chiaro e finire per mettere voti “a occhio”.',
  },
  {
    icon: 'users',
    title: 'Studenti disconnessi',
    text: 'Sentire che i ragazzi non vogliono partecipare e si stancano subito.',
  },
]

export type PackItem = {
  icon: IconName
  title: string
  text: string
}

export const packItems: PackItem[] = [
  {
    icon: 'bookOpen',
    title: '6 volumi basati sul QCER',
    text: 'Un curriculum completo, dallo Starter A1 alla maestria del C2.',
  },
  {
    icon: 'fileText',
    title: 'Schede attività «Ready-to-Teach»',
    text: 'Spiegazioni chiare, varianti e Teacher Tips per ogni lezione.',
  },
  {
    icon: 'layers',
    title: 'Visual Skill Cards',
    text: 'Risorse grafiche per spiegare tempi verbali e funzioni comunicative al volo.',
  },
  {
    icon: 'gauge',
    title: 'Placement test e certificazioni',
    text: 'Strumenti per mappare il livello iniziale e finale in 5 minuti.',
  },
  {
    icon: 'clipboardCheck',
    title: 'Valutazioni, rubriche e report',
    text: 'Tutto pronto per rendere il registro elettronico una formalità veloce.',
  },
  {
    icon: 'trendingUp',
    title: 'Chiavi di progressione linguistica',
    text: 'La roadmap per far migliorare i tuoi alunni anno dopo anno.',
  },
]

export type Level = {
  code: string
  name: string
}

export const levels: Level[] = [
  { code: 'A1', name: 'Starter' },
  { code: 'A2', name: 'Elementary' },
  { code: 'B1', name: 'Intermediate' },
  { code: 'B2', name: 'Upper-Int.' },
  { code: 'C1', name: 'Advanced' },
  { code: 'C2', name: 'Mastery' },
]

export type PageSample = {
  src: string
  level: string
  title: string
  caption: string
}

export const pageSamples: PageSample[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/f4CVtyoqzNjNiWhNUcBkfC/Captura-de-pantalla-2026-09-01-a-las-12.50.42_p._m..webp',
    level: 'A1 Starter · Scheda attività',
    title: 'Color by Number! — i colori in inglese',
    caption:
      'Due attività su una pagina: colorare seguendo il codice colori e scrivere il nome del colore. Consegne graduate con le stelline di difficoltà, pronte da fotocopiare.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tkNA8jvFF7gdGg3roE7MdB/Captura-de-pantalla-2026-09-01-a-las-12.51.46_p._m..webp',
    level: 'A2 Elementary · Unità visiva',
    title: 'Come descrivere una persona in inglese',
    caption:
      'Lessico di hair, eyes, height, body type e age con trascrizione fonetica e un mini-dialogo finale da proiettare su LIM o distribuire in classe.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pN1pbs5WBkqory6hBUshJG/Captura-de-pantalla-2026-09-01-a-las-12.52.53_p._m..webp',
    level: 'B1 Intermediate · Esercizi',
    title: 'Past simple: dal matching alla produzione scritta',
    caption:
      'Progressione in tre passi — abbinare i verbi irregolari, completare la storia, scrivere la propria — chiusa dal Teacher Script con le parole esatte da dire.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6GM3qfnC1WNTacrRvDmvNb/Captura-de-pantalla-2026-09-01-a-las-12.54.04_p._m..webp',
    level: 'B2 Upper-Int. · Visual Skill Cards',
    title: 'Flashcard da ritagliare: verbi, avverbi e phrasal verbs',
    caption:
      'Quattro carte per foglio con foto, frase d’esempio e definizione. Si stampano, si ritagliano e diventano l’attività di speaking di tutta la lezione.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7JxpAS68x9EcLtenrS45AC/Captura-de-pantalla-2026-09-01-a-las-12.55.10_p._m..webp',
    level: 'C1 Advanced · Valutazione',
    title: '«Posso farlo?» — indicatori di padronanza C1',
    caption:
      'Autovalutazione QCER su scala 1–4 per speaking, listening, reading e writing: la fotografia del livello reale della classe in cinque minuti.',
  },
]

export type Bonus = {
  title: string
  text: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Kit Primo Giorno Perfetto™',
    text: 'La risorsa per stabilire autorità e accoglienza dal primo minuto.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/337d7caa-0837-4794-98ab-ecaea3ec4ca3.jpg',
  },
  {
    title: 'Programmatore Lezioni in 5 Minuti™',
    text: 'Il sistema per strutturare le ore senza sprechi burocratici.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/197f914d-1706-4ae6-90ec-3255ddf610e0.jpg',
  },
  {
    title: 'Sistema di Monitoraggio Progressi™',
    text: 'Traccia i miglioramenti QCER dei tuoi studenti in modo semplice.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/eab8ce18-b956-469f-8893-63acb65d3f32.jpg',
  },
  {
    title: 'Kit Emergenza Supplenti™',
    text: 'Soluzione pronta per garantire continuità anche in tua assenza.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/5d774534-5ae1-4178-9d66-e1d6b6094ee1.jpg',
  },
  {
    title: 'Poster Pronti per l’Aula™',
    text: 'Design neurodidattico per un ambiente immersivo tutto l’anno.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/cd216d75-8484-406f-9c44-99d52a7b9794.jpg',
  },
]

export const offerRows = [
  { label: 'Kit Inglese Pronto™ (6 volumi)', value: '€65' },
  { label: '5 Bonus Strategici Esclusivi', value: '€45' },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente via email dopo il pagamento. Sono file PDF premium pronti per essere stampati o proiettati su LIM.',
  },
  {
    q: 'Serve molto materiale extra per le lezioni?',
    a: 'No. Il Kit è progettato per funzionare con risorse minime, ideale anche per aule con poca tecnologia.',
  },
  {
    q: 'Il pagamento è mensile?',
    a: 'Assolutamente no. È un pagamento unico di 19 euro per l’accesso a vita e tutti gli aggiornamenti futuri.',
  },
  {
    q: 'È adatto ai programmi ministeriali italiani?',
    a: 'Sì. Inglese Pronto™ è stato progettato seguendo le Indicazioni Nazionali e i parametri del QCER (Quadro Comune Europeo di Riferimento).',
  },
  {
    q: 'Posso stampare le schede per più classi?',
    a: 'Certamente. Una volta acquistato, il materiale è tuo e puoi usarlo con tutti i tuoi gruppi, anno dopo anno.',
  },
  {
    q: 'Quali metodi di pagamento accettate?',
    a: 'Accettiamo tutte le principali carte di credito, debito e PayPal per una sicurezza totale.',
  },
]
